export default __webpack_public_path__ + "static/media/660.163db9ab.gif";